import styled from '@emotion/styled'

export const Copyright = styled.div`
  align-items: center;
  border-top: 1px solid #C1C1C1;
  display: flex;
  font-family: Satoshi;
  font-size: 12px;
  font-weight: 400;
  justify-content: center;
  letter-spacing: 0%;
  line-height: 100%;
  margin-top: 2rem;
  max-width: 1440px;
  padding: 24px;
  width: 100%;
`
